import React from 'react';
import cn from 'classnames';

export type ScrollScrimDirection = 'top' | 'right' | 'bottom' | 'left';

export interface ScrollScrimProps {
  visible: boolean;
  direction: ScrollScrimDirection;
  className?: string;
  sizeClassName?: string;
}

const directionToClassName: Record<ScrollScrimDirection, string> = {
  top: 'top-0 left-0 right-0 bg-gradient-to-t from-transparent to-white',
  right: 'top-0 right-0 bottom-0 bg-gradient-to-r from-transparent to-white',
  bottom: 'bottom-0 left-0 right-0 bg-gradient-to-b from-transparent to-white',
  left: 'top-0 left-0 bottom-0 bg-gradient-to-l from-transparent to-white',
};

const directionToSizeClassName: Record<ScrollScrimDirection, string> = {
  top: 'h-6',
  right: 'w-20',
  bottom: 'h-6',
  left: 'w-20',
};

export const ScrollScrim: React.FC<ScrollScrimProps> = ({
  visible,
  direction,
  className,
  sizeClassName,
}) => {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute z-10 transition-opacity duration-150',
        directionToClassName[direction],
        sizeClassName ?? directionToSizeClassName[direction],
        visible ? 'opacity-100' : 'opacity-0',
        className,
      )}
    />
  );
};
